/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseExtraDataSchema } from "./errorResponseExtraDataSchema.ts";

export const yookassaPaymentCallbackObjectRequestSchema = z.object({
	id: z.uuid(),
	payment_id: z.uuid().nullish(),
	metadata: errorResponseExtraDataSchema.optional(),
});
